import {RoleTypes} from "../models/roles";
import {Injectable, ReflectiveInjector} from "@angular/core";
import {StaticDataService} from "./StaticData.service";
import {UsersModel} from "../models/users/users.model";
import {UsersService} from "../models/users/users.service";
import {Http, RequestOptions, XHRBackend} from "@angular/http";
import {Router} from "@angular/router";
import {Subject} from "rxjs";


class UserManager {
    user: UsersModel;
    key: string = 'melochenator:user';

    constructor() {
    }

    setUser (fields: UsersModel) {
        this.user = fields;
    }

    checkUser() {
        const user = this.obtain() || {};
        if (user.id) {
            this.setUser(user);
        }
        return !!user.id;
    }

    public store() {
        localStorage.setItem(this.key, JSON.stringify(this.user))
    }

    public obtain() {
        return JSON.parse(localStorage.getItem(this.key));
    }

    public remove() {
        localStorage.removeItem(this.key);
    }
}

@Injectable()
export class ApplicationUser {
    public loggedIN: boolean = false;
    public UserManager: UserManager = new UserManager();
    public StaticData: StaticDataService = new StaticDataService();

    public user: UsersModel;

    public originalUser: UsersModel;
    
    private static _instance:ApplicationUser = new ApplicationUser();


    private _onAfterLogin = new Subject<any>();
    public onAfterLogin = this._onAfterLogin.asObservable();


    private _onAfterLogout = new Subject<any>();
    public onAfterLogout = this._onAfterLogout.asObservable();


    constructor() {
        ApplicationUser._instance = this;

        this.checkUser();
    }

    public static getInstance():ApplicationUser {
        return ApplicationUser._instance;
    }

    public checkUser() {
        let originalUser = JSON.parse(localStorage.getItem('originalUser'));
        if (originalUser) {
            this.originalUser = originalUser;
        }

        if (this.UserManager.checkUser()) {
            this.user = this.UserManager.user;
            this.loggedIN = true;
            return true;
        }

        this.user = null;
        this.loggedIN = false;
        return false;
    }

    public switchUser(userFields: UsersModel) {
        if (!this.originalUser) {
            this.originalUser =  this.user;
        }
        this.user = userFields;
    }

    public updateUser(userFields: UsersModel) {
        this.UserManager.setUser(userFields);
        this.UserManager.store();
    }

    public login(userFields: UsersModel) {
        this.UserManager.setUser(userFields);
        this.UserManager.store();
        this.user = this.UserManager.user;
        this.originalUser =  this.UserManager.user;
        this.loggedIN = true;

        this._onAfterLogin.next(this.originalUser );
    }

    public logout() {
        this.UserManager.remove();
        this.StaticData.remove();
        this.user = null;
        this.originalUser = null;
        localStorage.removeItem('originalUser');
        this.loggedIN = false;

        this._onAfterLogout.next('');
    }

    public getAccessToken() {
        if (!this.loggedIN) {
            return '';
        }
        return this.UserManager.obtain().access_token;
    }
    
    public hasRole(roles: Array<RoleTypes>): boolean {
        if (!this.loggedIN) return false;
        
        // check user role
        if (roles.indexOf(this.UserManager.user.role) === -1) {
            return false;
        }
        
        return true;
        
    }
}


// WEBPACK FOOTER //
// ./src/app/services/ApplicationUser.ts